import React, { Component } from 'react'; 
import {
    withGoogleMap,
    GoogleMap,
    Marker,
    DirectionsRenderer,
    withScriptjs,
  } from "react-google-maps" 
import axios from 'axios'
import Notification from 'rc-notification';
import 'rc-notification/assets/index.css';
import ModalConnection from './ModalConnectionSubscribe';
import {doSignOut} from '../authDB';

let notification = null;
Notification.newInstance({}, (n) => notification = n);



  const MapUserLocation =withScriptjs(withGoogleMap(props =>
    <GoogleMap
        defaultZoom={15}
        defaultCenter={{lat:35.8364142,lng:10.595896399999999}}
    >
        {props.children}
    
  
        
         
    </GoogleMap>
  ));


 
class App extends Component {


    constructor(){
        super()
        this.state={
            email:"",
            name:"",
            message:"",
            phone:""

        }
    }
    show_connection(){
        this.refs.ModalConnection.handleShow();
    console.log(this.refs)
    }
    Deconx(){
      localStorage.removeItem('user')
      doSignOut().then(()=>{
        window.parent.location = window.parent.location.href;
    
      })
    }

    contacter(){
        var that=this
        if(this.state.email&& this.state.phone&&  this.state.name 
            && this.state.message)
        {axios.get('https://intense-reaches-19510.herokuapp.com/contact', {
            params: {
               
                email:this.state.email,
                name:this.state.name,
                message:this.state.message,
                phone:this.state.phone
    
    
    
    
    
    
            }
          })
          .then(function (response) {
              that.setState({
                email:"",
                name:"",
                message:"",
                phone:""
              })
            console.log(response);
          })
          .catch(function (error) {
           // console.log(error);
            //alert("error")

            notification.notice({
                content: <span style={{fontSize:20}}><i class="fa fa-warning" style={{fontSize:20,color:'red',marginRight:20}}></i>Erreur</span>, 
                duration: 5,
                onClose() {
                  console.log('closable close');
                },
                closable: true,
              });
          });}
          else
          {
            //alert("champs vide")
            notification.notice({
                content: <span style={{fontSize:20}}><i class="fa fa-warning" style={{fontSize:20,color:'red',marginRight:20}}></i>champs vide</span>, 
                duration: 5,
                onClose() {
                  console.log('closable close');
                },
                closable: true,
              });
          }
    
    }
  render() {
    return (
   <div>
         <header className="header">
            <div className="container">
                <div className="menubar">
                    <div className="row">
                        <div className="col-md-12">
                            <nav className="navbar navbar-static-top">
                             <div className="navbar-header">
                                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" aria-expanded="false">
                                        <span className="sr-only">Toggle navigation</span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                    </button>
                                    <a className="navbar-brand" href="/">
                                        <img src="/images/logo.png" className="img-responsive" alt="logo"/>
                                    </a>
                                </div>                      
     <div className="collapse navbar-collapse ">
                                    <ul className="nav navbar-nav navbar-right">
                                    
                                    <li className="res-btn">
                                          {(JSON.parse(localStorage.getItem('user')))?  <button onClick={()=>this.Deconx()} className="book-btn">Déconnection</button>:<button onClick={()=>this.show_connection()} className="book-btn">Connexion</button>}
                                    </li>
                                    </ul>
                                    <ul className="nav navbar-nav navbar-right" id="main-menu">

                                    <li className="">

                                         <a  href="/">
                                                Accueil
                                         </a>
                                    </li>
                                        {/*    <li className="">
                                            <a  href="/about">À propos</a>
    </li>*/}
                                        <li className="">
                                            <a  href="/order">Menu</a>                                          
                                        </li>
                                        {(JSON.parse(localStorage.getItem('user')))?  <li className="">
                                            <a  href="/historique">Historique</a>
                                        </li>:null       }     
                                        {(JSON.parse(localStorage.getItem('user')))?   <li className="">
                                            <a href="/loyalty">
                                            Fidélité
                                            </a>
                                        </li>  :null       } 
                                        <li className="">
                                            <a   href="/Blog">
                                                Blog
                                            </a>
                                        </li>     
                                                          
                                        <li className="active">
                                            <a   href="/contact">
                                                Contact
                                            </a>
                                        </li>  
                                                                           
                                    </ul>
                                </div>  
                            </nav>
                        </div>
                    </div>
                </div>

            </div>
            <div className="mobile-menu" data-logo="/images/logo.png">


            </div>



        </header>
       
        <section className="page-title">
    <div className="container">
        <h2 className="title">
            Contactez Nous
        </h2>
        <ul className="brdcrumb clearfix">
            <li>
                <a href="/">Accueil</a>
            </li>
           
            <li className="current">
                Contact
            </li>
        </ul>
    </div>
</section>
<section className="contact-section section-padding">
    <div className="container">
        <div className="row">
            <div className="col-md-4 col-sm-6">
                <h3 className="main-title text-left">
                    <span>
                Contactez Nous
                    </span>
                </h3>
            </div>
        </div>
        <div className="row">
            <div className="col-md-8">

                <div className="row">
                    <div className="col-md-10">


                        <div className="sub-title">
                            <p>
                            Ce formulaire est destiné à obtenir des informations. Il n’est pas valable pour les réservations.
                            </p>
                        </div>
                    </div>
                </div>
                <div  className="reserv-form">
                    <div className="input-box">
                        <input type="text" value={this.state.name} onChange={(e=>{

this.setState({name:e.target.value})
})}  className="form-control" placeholder="Nom"/>
                        <span>
                            <i className="fa fa-pencil"></i>
                        </span>
                    </div>
                    <div className="input-box">
                        <input type="text" value={this.state.phone} onChange={(e=>{

this.setState({phone:e.target.value})
})}  className="form-control" placeholder="Téléphone"/>
                        <span>
                            <i className="fa fa-phone"></i>
                        </span>
                    </div>
                    <div className="input-box">
                        <input type="text" 
                        value={this.state.email} onChange={(e=>{

                            this.setState({email:e.target.value})
                            })} 
                        className="form-control" placeholder="Email"/>
                        <span>
                            <i className="fa fa-envelope-o"></i>
                        </span>
                    </div>
                    <div className="input-box">
                        <textarea value={this.state.message} onChange={(e=>{

this.setState({message:e.target.value})
})}  className="form-control" placeholder="Votre Message"></textarea>
                    </div>


                    <button onClick={()=>this.contacter()} className="btn-secondry" value="Send Message">Envoyer Message</button>
                </div>
            </div>
            <div className="col-md-4">
                <ul className="contact">
                    <li>

                        <div className="icon">
                            <img src="images/con1.jpg" alt="contact"/>
                            <i className="fa fa-map-marker"></i>
                        </div>
                        <p className="title">Adresse:</p>
                        <p> Avenue Yasser Arafat, complexe Rosaria Sahloul</p>

                    </li>

                    <li>

                        <div className="icon">
                            <img src="images/con2.jpg" alt="contact"/>
                            <i className="fa fa-phone"></i>
                        </div>
                        <p className="title">Appelez-Nous:</p>
                        <p>
                        +216 50 406 487
                           
                        </p>

                    </li>
                    <li>

                        <div className="icon">
                            <img src="images/con3.jpg" alt="contact"/>
                            <i className="fa fa-envelope"></i>
                        </div>
                        <p className="title">Email:</p>
                        <p>
                            contact@bistro73.tn
                        </p>

                      </li>
                </ul>

                <p className="min-title"> SUIVEZ-NOUS SUR</p>
                <ul className="mini-social m-top20">
                    <li>
                        <a href="https://www.facebook.com/bistro73Sousse/">
                            <i className="fa fa-facebook"></i>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i className="fa fa-google-plus"></i>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i className="fa fa-instagram"></i>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i className="fa fa-twitter"></i>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i className="fa fa-linkedin"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>


        <div className="map">
        <MapUserLocation
  containerElement={<div style={{ height: '100%' }} />}
  mapElement={<div style={{ height: '400px' }} />}
  googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyC9z2ExBdH_ALjzifswDY5HY9sQZ5qM3Mw&language=fr&region=FR"
  loadingElement={<div style={{ height: `50%` }} />}

>
  <Marker
    position={{ lat:35.8364142, lng: 10.595896399999999 }}
  />
</MapUserLocation>
        </div>
    </div>
</section>

<section className="call-out-section section-padding">
    <div className="container">
        <div className="row">
            <div className="col-md-10">
                <h2>Découvrez le vrai goût de notre nourriture.</h2>
            </div>
            <div className="col-md-2">
                <div className="call-out-btn">
                    <a href="/contact" className="btn-custom">Contact Us</a>
                </div>
            </div>
        </div>
    </div>
</section>


   
   <ModalConnection ref="ModalConnection"/>

    </div>


   
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/container/contact.js